<template>
    <div class="countDownTimer" v-if="timerStatus">
        {{text}} {{countDown}}
    </div>
</template>
<script>
export default {
    name: 'CountDown',
    props: {
        text: {
            type: String,
            default: null
        },
        secondsTime: {
            type: Number,
            default: 30
        },
        timerDisplayStatus: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            countDown: "00:00",
            seconds: "-",
            timerStatus: false
        }
    },
    created() {
        var self = this;
        if (self.timerDisplayStatus) {
            self.timerStatus = true;
            self.seconds = self.secondsTime;
            self.countDown = "00:"+(self.secondsTime < 10 ? "0"+self.secondsTime : self.secondsTime)
            self.startTimer();
        } else {
            self.timerStatus = false;
        }
    },
    methods: {
        startTimer () {
            var self = this;
            if (self.seconds > 0 && self.seconds != 0) {
                setTimeout(() => {
                    self.seconds -= 1
                    if (self.seconds >= 0) {
                        self.countDown = "00:"+(self.seconds < 10 ? "0"+self.seconds : self.seconds);
                        self.startTimer()
                    }
                }, 1000)
            } else {
                self.timerStatus = false;
                self.$emit('timerCompleted', self.timerStatus);
            }
        },
    }

}
</script>